<template>
    <NuxtLayout name="main">
        <section
            class="bg-[url('https://rdgta.cdn.cyagen.com/rddc/images/citations/cover.png')] bg-no-repeat bg-cover w-[100%] pt-[134px] pb-[114px] max-xl:pt-[72px] max-xl:pb-[76px] max-lg:pt-[88px] max-lg:pb-[92px]">
            <div class="container">
                <div class="text-white text-[56px] leading-[56px] font-bold ax-lg:text-[40px] max-lg:leading-[40px]">{{ $t("Citations") }}</div>
                <div class="mt-[24px] text-white text-[20px] leading-[36px] max-lg:mt-[16px] max-lg:text-[16px] max-lg:leading-[32px]">
                    {{ $t("CitationsDesc") }}
                </div>
            </div>
        </section>
        <section class="container pt-[80px] flex">
            <div class="w-[304px] max-xl:w-[264px] max-lg:w-[224px]">
                <div class="mb-[24px] text-emphas text-[30px] leading-[42px] font-bold">{{ $t("Filters") }}</div>
                <div v-for="value in filters" class="mb-[8px] last:mb-0 rounded-[4px]" :class="[css.filters, category == value.name && css.active]">
                    <div class="rounded-[4px] px-[24px] leading-[46px] t-delay-[0.3s] text-emphas font-bold bg-[#eeeeee]" :class="css.category">
                        {{ value.name }}
                    </div>
                    <div class="py-[16px]">
                        <div
                            v-for="option in value.options"
                            class="mb-[8px] last:mb-0 px-[40px] leading-[30px] cursor-pointer hover:text-emphas hover:font-bold"
                            :class="filter == option.value ? 'text-emphas font-bold' : ''"
                            @click="
                                filter = option.value;
                                acquire(1);
                            ">
                            {{ option.label }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-1 pl-[80px] max-xl:pl-[72px] max-lg:pl-[64px]" v-loading="loading">
                <div class="mt-[70px]">
                    <div v-for="value in data" class="flex mb-[16px] last:mb-0">
                        <div class="px-[40px] py-[24px] t-border-uicolor4 border-r-0 rounded-l-[4px] flex-1 max-lg:px-[32px] max-lg:py-[16px]">
                            <div class="leading-[24px]">{{ value.journal }}, {{ value.date }}</div>
                            <div class="mt-[2px] text-[20px] leading-[28px] font-bold text-emphas line-clamp-2">{{ value.title }}</div>
                            <div v-if="value.sub_category" class="mt-[16px] inline-block bg-color4 leading-[32px] px-[12px] rounded-[4px] text-main">
                                {{ value.sub_category }}
                            </div>
                        </div>
                        <project-route
                            target="_blank"
                            :to="value.url"
                            class="w-[192px] shrink-0 rounded-r-[4px] flex items-center justify-center text-white bg-main hover:text-white visited:text-white max-lg:w-[164px]">
                            {{ $t("ViewDetails") }} >>
                        </project-route>
                    </div>
                </div>
                <ui-pagination class="mt-[40px]" v-model="page" :count="count" @change="acquire">
                    <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 10 }) }}</template></ui-pagination
                >
            </div>
        </section>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* 组件库
import { UiPagination } from "various-ui";
//* 组件属性
import type { CitationsData, CitationsFilters } from "./index";

//* 样式
import css from "./index.module.less";

//* 获取初始数据
const options = await api.server("Citations", "/api/citations", { method: "POST" });
const { filters } = options.value;

//* 响应式数据
const loading = ref<boolean>(false);
const page = ref<number>(1);
const count = ref<number>(options.value.count || 0);
const data = ref<CitationsData[]>(options.value.data || []);
const filter = ref<string>("");

const category = computed(() => {
    return filters.find((category: CitationsFilters) => category.options.some((option) => option.value === filter.value))?.name;
});

//* 获取数据
const acquire = (number?: number) => {
    //* 数据更新
    loading.value = true;
    page.value = number || page.value;
    //* 接口请求
    api.frontend(`/api/citations`, {
        method: "POST",
        data: {
            page: page.value,
            filter: filter.value,
        },
        success: (response) => {
            count.value = response.count;
            page.value = response.page;
            data.value = response.data;
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        finally: () => (loading.value = false),
    });
};
</script>
